<template>
    <div class="text-sm">
        <span class="text-base font-medium text-info">Détails de l'intervention</span>
        <div class="md-layout md-gutter mt-3">
            <div class="md-layout-item md-size-100">
                <div>
                    <span class="font-medium">Type d'intervention :</span>
                    <span class="ml-1">{{ intervention.category.name }}</span>
                </div>
                <div>
                    <span class="font-medium">Date & heure :</span>
                    <span class="ml-1">Le
                        {{ $moment(intervention.planningable.start_date).format('DD/MM/YYYY')
                                + ' à ' +
                                $moment(intervention.planningable.start_date).format('HH:mm') }}
                        pour une durée de {{ intervention.duration }} minutes
                    </span>
                </div>
                <div>
                    <span class="font-medium">Type d'intervention :</span>
                    <span class="ml-1">{{ intervention.intervention_type.name }}</span>
                </div>
                <div>
                    <span class="font-medium">Commentaire :</span>
                    <span class="ml-1">{{ intervention.comment ? intervention.comment : 'Ø' }}</span>
                </div>
                <md-divider class="my-2"></md-divider>
                <div>
                    <span class="font-medium text-base text-info mb-2">Historique</span>
					<log v-for="log in intervention.logs" :key="log.id"
						:date="log.created_at"
						:message="log.message"
						:author="log.user"></log>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Log from "/src/components/Logs/Log";
export default {
    name: "TabIntervention",
	components: {
		Log
	},
    props: {
        interventionId: Number,
        active: Boolean
    },
    data() {
        return {
            intervention: {
                planningable: {},
                intervention_type: {},
                category: {},
				logs: []
            }
        }
    },
    methods: {
        async getInterventionDetails() {
            const { data } = await this.$store.dispatch('calendar/getModalIntervention', {
                interventionId: this.interventionId
            })
            this.intervention = data
        },
    },
    mounted() {
        if(this.active) {
            this.getInterventionDetails()
        }
    },
    watch: {
        active(newVal) {
            if(newVal) {
                this.getInterventionDetails()
            }
        }
    }
}
</script>

<style scoped>

</style>
